import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {stickyHeaderHeight} from "../list/constants/sticky_header_height";

export interface IOfferListingStore {
    isListingNavigationSticky: boolean;
    stickyHeaderVisibility: 0 | 1;
    stickyHeaderCurrentHeight: number;
}

export const offerListingSliceInitialState: IOfferListingStore = {
    isListingNavigationSticky: false,
    stickyHeaderVisibility: 0,
    stickyHeaderCurrentHeight: stickyHeaderHeight
};

export const offerListingSlice = createSlice({
    name: "offerListing",
    initialState: offerListingSliceInitialState,
    reducers: {
        setOfferListingNavigationSticky: (state, action: PayloadAction<boolean>) => {
            state.isListingNavigationSticky = action.payload;
        },
        setStickyHeaderVisibility: (state, action: PayloadAction<0 | 1>) => {
            state.stickyHeaderVisibility = action.payload;
        },
        setStickyHeaderCurrentHeight: (state, action: PayloadAction<number>) => {
            state.stickyHeaderCurrentHeight = action.payload;
        }
    }
});

export const {setOfferListingNavigationSticky, setStickyHeaderVisibility, setStickyHeaderCurrentHeight} = offerListingSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {stickyHeaderHeight} from "../list/constants/sticky_header_height";

export interface IOfferListingStore {
    isListingNavigationSticky: boolean;
    stickyHeaderVisibility: 0 | 1;
    stickyHeaderCurrentHeight: number;
}

export const offerListingSliceInitialState: IOfferListingStore = {
    isListingNavigationSticky: false,
    stickyHeaderVisibility: 0,
    stickyHeaderCurrentHeight: stickyHeaderHeight
};

export const offerListingSlice = createSlice({
    name: "offerListing",
    initialState: offerListingSliceInitialState,
    reducers: {
        setOfferListingNavigationSticky: (state, action: PayloadAction<boolean>) => {
            state.isListingNavigationSticky = action.payload;
        },
        setStickyHeaderVisibility: (state, action: PayloadAction<0 | 1>) => {
            state.stickyHeaderVisibility = action.payload;
        },
        setStickyHeaderCurrentHeight: (state, action: PayloadAction<number>) => {
            state.stickyHeaderCurrentHeight = action.payload;
        }
    }
});

export const {setOfferListingNavigationSticky, setStickyHeaderVisibility, setStickyHeaderCurrentHeight} = offerListingSlice.actions;
